import Vue from 'vue';
import Cookie from 'js-cookie';

const initialUser = {
  id: Cookie.get('id'),
	profile: Cookie.get('profile') || localStorage.getItem('profile'),
	token: Cookie.get('token'),
	email: Cookie.get('email'),
	telefone: Cookie.get('telefone'),
	nome: Cookie.get('nome'),
	full_name: Cookie.get('full_name'),
	unidade: Cookie.get('unidade'),
	aceite_termos_lgpd: Cookie.get('aceite_termos_lgpd'),
	empreendimento_id: Cookie.get('empreendimento_id'),
	empreendimento_logo: Cookie.get('empreendimento_logo'),
	empreendimento_ico: Cookie.get('empreendimento_ico'),
	construtora_id: Cookie.get('construtora_id'),
	construtora_logo: Cookie.get('construtora_logo'),
	primeiro_acesso: Cookie.get('primeiro_acesso'),
	permissoes: Cookie.get('permissoes'),
	is_construtora: Cookie.get('is_construtora'),
	assistencia_tecnica_construtora_filtro: Cookie.get('assistencia_tecnica_construtora_filtro'),
	user_ip: Cookie.get('user_ip'),
	ip_expired_at: Cookie.get('user_ip_expired_at'),
	integracao_xrm: Cookie.get('integracao_xrm'),
	decorrencia_chamado: Cookie.get('decorrencia_chamado'),
	construtora_created_at: Cookie.get('construtora_created_at'),
	empreendimento_created_at: Cookie.get('empreendimento_created_at'),
	// Vigência da garantia do empreendimento (GUIARE-67). Mora aqui, e não em um
	// estado próprio, para que o logout limpe junto com o resto da sessão.
	garantia_ativa: Cookie.get('garantia_ativa'),
	garantia_contratada: Cookie.get('garantia_contratada'),
	garantia_inicio: Cookie.get('garantia_inicio'),
	garantia_fim: Cookie.get('garantia_fim'),
	garantia_encerrada_em: Cookie.get('garantia_encerrada_em')
};

export const user = Vue.observable(initialUser);

export const removeUserInfo = () => {
	Object.keys(user).forEach((key) => {
		user[key] = '';
		Cookie.remove(key);
	});
};

export default user;